import {
  createNestablePublicClientApplication
} from "@azure/msal-browser";


const CLIENT_ID =
  "aaa5d634-e673-4b32-bad2-7b3160d0dbca";

const TENANT_ID =
  "ab45de09-920b-474d-94c4-cdbaf4d2ec8d";

const AUTHORITY =
  `https://login.microsoftonline.com/${TENANT_ID}`;

const SCOPES = [
  "User.Read"
];


let msalInstance = null;


async function getMsalInstance() {

  if (msalInstance) {
    return msalInstance;
  }

  msalInstance =
    await createNestablePublicClientApplication({
      auth: {
        clientId: CLIENT_ID,
        authority: AUTHORITY
      }
    });

  return msalInstance;
}


async function getAccessToken() {

  const app =
    await getMsalInstance();

  try {

    const silentResult =
      await app.acquireTokenSilent({
        scopes: SCOPES
      });

    return silentResult.accessToken;

  } catch (silentError) {

    console.log(
      "Token silencioso não disponível. Solicitando autenticação.",
      silentError
    );

    const interactiveResult =
      await app.acquireTokenPopup({
        scopes: SCOPES
      });

    return interactiveResult.accessToken;
  }
}


async function getGraphProfile(accessToken) {

  const endpoint =
    "https://graph.microsoft.com/v1.0/me" +
    "?$select=" +
    "displayName," +
    "jobTitle," +
    "mail," +
    "userPrincipalName," +
    "mobilePhone," +
    "businessPhones," +
    "department," +
    "officeLocation";

  const response =
    await fetch(endpoint, {
      headers: {
        Authorization:
          `Bearer ${accessToken}`
      }
    });

  if (!response.ok) {

    const body =
      await response.text();

    throw new Error(
      `Microsoft Graph retornou ${response.status}: ${body}`
    );
  }

  return response.json();
}


function renderProfile(profile) {

  const container =
    document.getElementById("graph-result");

  if (!container) {
    return;
  }

  const businessPhone =
    Array.isArray(profile.businessPhones) &&
    profile.businessPhones.length > 0
      ? profile.businessPhones[0]
      : "";

  container.innerHTML = `
    <div class="label">Nome</div>
    <div class="value">${profile.displayName || "Não informado"}</div>

    <div class="label">Cargo</div>
    <div class="value">${profile.jobTitle || "Não informado"}</div>

    <div class="label">Departamento</div>
    <div class="value">${profile.department || "Não informado"}</div>

    <div class="label">E-mail</div>
    <div class="value">${profile.mail || profile.userPrincipalName || "Não informado"}</div>

    <div class="label">Celular</div>
    <div class="value">${profile.mobilePhone || "Não informado"}</div>

    <div class="label">Telefone comercial</div>
    <div class="value">${businessPhone || "Não informado"}</div>

    <div class="label">Local do escritório</div>
    <div class="value">${profile.officeLocation || "Não informado"}</div>
  `;
}


async function testGraph() {

  const button =
    document.getElementById("graph-test");

  const status =
    document.getElementById("graph-status");

  const result =
    document.getElementById("graph-result");

  button.disabled = true;

  status.className = "";
  status.textContent =
    "Conectando ao Microsoft 365...";

  result.innerHTML = "";

  try {

    const token =
      await getAccessToken();

    status.textContent =
      "Autenticação concluída. Consultando Microsoft Graph...";

    const profile =
      await getGraphProfile(token);

    status.textContent =
      "Microsoft Graph conectado com sucesso.";

    renderProfile(profile);

  } catch (error) {

    console.error(
      "CWF Graph authentication error:",
      error
    );

    status.className = "error";

    status.textContent =
      `Erro: ${error.message || error}`;

  } finally {

    button.disabled = false;
  }
}


Office.onReady(() => {

  const userElement =
    document.getElementById("user");

  if (
    typeof Office !== "undefined" &&
    Office.context &&
    Office.context.mailbox
  ) {

    const profile =
      Office.context.mailbox.userProfile || {};

    userElement.textContent =
      `${profile.displayName || "Usuário"} — ` +
      `${profile.emailAddress || "e-mail não informado"}`;

  } else {

    userElement.textContent =
      "Modo navegador — Outlook não conectado.";
  }


  const graphButton =
    document.getElementById("graph-test");

  if (graphButton) {

    graphButton.addEventListener(
      "click",
      testGraph
    );
  }
});